/* Journal: topic chips filter the list in the browser; bar diagrams grow when scrolled into view. */
(function () {
  var list = document.querySelector('[data-jr-list]');
  if (list) {
    var chips = list.querySelectorAll('[data-jr-tag]'), cards = list.querySelectorAll('.jr-card');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var tag = c.getAttribute('data-jr-tag');
        chips.forEach(function (x) { x.classList.toggle('is-on', x === c); });
        cards.forEach(function (card) {
          var has = !tag || (' ' + card.getAttribute('data-jr-tags') + ' ').indexOf(' ' + tag + ' ') > -1;
          card.hidden = !has;
        });
      });
    });
  }
  var bars = document.querySelectorAll('.jr-bars');
  if (bars.length) {
    if (!('IntersectionObserver' in window)) { bars.forEach(function (b) { b.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .35 });
    bars.forEach(function (b) { io.observe(b); });
  }
})();
